import mock from './mock'

import './apps/chat'
import './apps/todo'
import './apps/email'
import './apps/invoice'
import './apps/calendar'
import './apps/userList'
import './apps/eCommerce'
import './apps/permissionsList'
import './apps/faq'

mock.onAny().passThrough()
